module.exports = __webpack_public_path__ + "assets/img/s3-subtitle-3-9eb3267d.png";